module.exports = __webpack_public_path__ + "img/loader2.40549598.svg";